// extracted by mini-css-extract-plugin
module.exports = {"confirm_block":"ConfirmBlock_confirm_block__1t3z1"};